module.exports = __webpack_public_path__ + "img/兴发.2a1f0e22.png";